import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { painCards } from '../../data/salesContent';
export function ProblemSection() {
  return <section className="bg-ink px-5 py-20 md:py-28" data-id="element-149" data-mp="8l3ago1uv2ll">
      <div className="mx-auto max-w-6xl" data-id="element-150" data-mp="8kab48587fdh">
        <SectionHeading title="¿Cuántas horas más vas a perder preparando cada capacitación?" data-id="element-151" data-mp="djmz4w7u2shn" />
        <div className="mx-auto mt-10 max-w-3xl text-center" data-id="element-152" data-mp="3vprkcztoah6n">
          <p className="text-2xl font-bold text-cream md:text-3xl" data-id="element-153" data-mp="3vo84vbfuca5x">Sabés primeros auxilios.</p>
          <p className="mt-4 text-lg leading-relaxed text-neutral-400 md:text-xl" data-id="element-154" data-mp="3n1tq9rwjfda">
            El problema aparece cuando tenés que transformar ese conocimiento en una clase clara, práctica y evaluable.
          </p>
          <p className="mt-8 rounded-2xl border border-gold/40 bg-ink-soft px-6 py-5 font-display text-xl font-black uppercase leading-snug text-cream md:text-2xl" data-id="element-155" data-mp="3qsj3d2k9gj6z">
            No te falta conocimiento. <span className="text-gold" data-id="element-156" data-mp="1owz79jamlx9m">Te falta un sistema.</span>
          </p>
        </div>

        <ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-157" data-mp="1nm05upe0z6ey">
          {painCards.map(p => <li key={p} className="flex items-start gap-4 rounded-2xl border border-ink-line bg-ink-raised p-6" data-id="element-158" data-mp="1iohrukl5i103">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-red-400/40 text-red-400" data-id="element-159" data-mp="1wi90zruyziva">
                <XIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-160" data-mp="14ogqz54vytkm" />
              </span>
              <span className="text-lg font-medium leading-snug text-cream" data-id="element-161" data-mp="zqf8albdgw9o">{p}</span>
            </li>)}
        </ul>

        <div className="mt-14 text-center" data-id="element-162" data-mp="1dpwzt8g1ynmq">
          <p className="text-lg text-neutral-400 md:text-xl" data-id="element-163" data-mp="1dnkcsgvftn2t">Y cuando terminás una capacitación...</p>
          <p className="mt-3 font-display text-2xl font-black uppercase leading-tight text-cream md:text-3xl" data-id="element-164" data-mp="18sojzeidmvon">
            En la siguiente volvés a hacer <span className="text-gold" data-id="element-165" data-mp="2k6ijajsz5oho">gran parte del trabajo.</span>
          </p>
        </div>
      </div>
    </section>;
}